import { render, staticRenderFns } from "./BoosterShop.vue?vue&type=template&id=10e39265&scoped=true"
import script from "./BoosterShop.vue?vue&type=script&lang=js"
export * from "./BoosterShop.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=10e39265&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e39265",
  null
  
)

export default component.exports